import { useContext } from 'react';
import { AuthContext, AuthContextType } from 'Contexts';

export const useAuthContext = (): AuthContextType => {
  const context = useContext(AuthContext);

  return context;
};
